import { createFileRoute } from "@tanstack/react-router";
import { PortalPageHeader } from "@/components/portal-page-header";
import { useTeacherClassesGetTeacherClassDetail } from "@/orval/teacher-classes";
import { TeacherClassUpdateEditor } from "./-components/teacher-class-update-editor";

export const Route = createFileRoute("/_app/organizations/$organizationId/teacher/classes_/$classId/updates/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId, classId } = Route.useParams();
  const { data: classDetail } = useTeacherClassesGetTeacherClassDetail(organizationId, classId);

  return (
    <>
      <PortalPageHeader
        className="mb-6"
        breadcrumbs={[
          { label: "Classes", to: "/organizations/$organizationId/teacher/classes", params: { organizationId } },
          {
            label: classDetail?.name ?? "Class",
            to: "/organizations/$organizationId/teacher/classes/$classId",
            params: { organizationId, classId },
          },
          {
            label: "Updates",
            to: "/organizations/$organizationId/teacher/classes/$classId/updates",
            params: { organizationId, classId },
          },
          { label: "New Update" },
        ]}
        title="New Update"
        subtitle="Create an update for enrolled families."
      />

      <div className="mx-auto w-full max-w-3xl">
        <TeacherClassUpdateEditor organizationId={organizationId} classId={classId} />
      </div>
    </>
  );
}
